import * as Yup from 'yup';
import { AlertSection } from '../../../../../../shared/types/legalProceedings/alerts';

export const initialValues: AlertSection = {
    alertDate: '',
    classification: '',
    numberDays: '0',
    alertByMail: false,
    emailOfficials: '',
    tags: '',
    subject: '',
    template: '',
    body: '',
    areaException: [],
};

export const validationSchema = () =>
    Yup.object({
        alertDate: Yup.string().required('La fecha es obligatoria'),
        classification: Yup.string().required(
            'La clasificación es obligatoria'
        ),
        numberDays: Yup.string().required('El número de dias es obligatorio'),
        alertByMail: Yup.boolean(),
        emailOfficials: Yup.string().when('alertByMail', {
            is: true,
            then: () =>
                Yup.string().required(
                    'El correo de los funcionarios es obligatorio'
                ),
        }),
        tags: Yup.string().when('alertByMail', {
            is: true,
            then: () => Yup.string().required('El tags es obligatorio'),
        }),
        subject: Yup.string().when('alertByMail', {
            is: true,
            then: () => Yup.string().required('El asunto es obligatorio'),
        }),
        template: Yup.string().when('alertByMail', {
            is: true,
            then: () =>
                Yup.string().required('El cuerpo del correo es obligatorio'),
        }),
    });
